<template>
  <b-container class="container-terminal">
    <b-row
      id="main-text-container"
      class="row-main-text mt-2"
    >
      <b-container
        class="text-terminal"
        @mouseover="onHover('Terminal/terminalText')"
        @mouseleave="onLeave"
      >
        <b-row class="mx-1 my-1">
          <p class="main-text initial-text">
            Djuli [Version {{ version }}]
          </p>
        </b-row>
        <b-row class="mt-0 mb-5 mx-1">
          <p class="main-text initial-text">
            (c)2020 Zimmer and Peacock. All rights reserved.
          </p>
        </b-row>
        <b-row
          v-for="message in getMessagesTerminalSection"
          :key="message.id"
          class="my-3 command-terminal w-100"
        >
          <p :class="['head-text',message.type]">
            {{ message.type }}.
          </p>
          <p :class="['main-text',message.type]">
            {{ message.text }}
          </p>
        </b-row>
      </b-container>
    </b-row>
    <b-row>
      <b-col
        @mouseover="onHover('Terminal/textInput')"
        @mouseleave="onLeave"
      >
        <b-input
          v-model="commandText"
          cols="11"
          placeholder="Enter the command"
          autocomplete="off"
          :disabled="disableInput"
          @keyup="keyPressedInput"
        />
      </b-col>
      <b-col
        cols="1"
        @mouseover="onHover('Terminal/textEnter')"
        @mouseleave="onLeave"
      >
        <b-button
          variant="primary"
          :disabled="disableInput"
          @click="sendCommand"
        >
          Enter
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import TerminalFunctions from '@/functions/terminalFunctions.js'
import packageJson from '@/../package.json';

const version = packageJson.version || 0;

export default {
  name: 'Terminal',
  data() {
    return {
      commandText:'',
      disableInput:false,
      version
    }
  },
  computed: {
    ...mapGetters(['getMessagesTerminalSection','isVisibleStateReportViewer','getCommandHistTerminalSection','getCountCommandTerminalSection'])
  },
  mounted(){
    this.scrollToEnd();
  },
  updated(){
    this.scrollToEnd();
  },
  methods: {
    ...mapActions([
      'incrementCountTerminalSection',
      'decrementCountTerminalSection',
      'setContextOnHover',
      'clearCountTerminalSection'
    ]),
    onHover(route) {
      this.setContextOnHover(route)
    },
    onLeave(){
      this.setContextOnHover(null)
    },
    async sendCommand(){
      this.disableInput = true
      TerminalFunctions.executeCommand(this,this.commandText)
      this.commandText=''
      this.disableInput = false
    },
    scrollToEnd(){
      var container = this.$el.querySelector('#main-text-container');
      container.scrollTop = container.scrollHeight;
    },
    keyPressedInput(e) {
      if (e.keyCode === 13) { //Enter
        this.sendCommand()
        this.clearCountTerminalSection()
      }else if(e.keyCode===38){ //Key Up
        this.incrementCountTerminalSection()
        this.recoverCommand()
      }else if(e.keyCode===40){ //Key Down
        this.decrementCountTerminalSection()
        this.recoverCommand()
      }
    },
    recoverCommand(){
      if(this.getCountCommandTerminalSection===0){
        this.commandText=''
      }else{
        this.commandText = this.getCommandHistTerminalSection
      }
    }
  }
}

</script>

<style scoped>
.row-main-text{
  border: #777 solid 3px;
  background-color: #EEE;
  height: 85vh;
  overflow-y: auto;
  border-radius: 15px;
  white-space: pre;
}
.main-text{
  margin:0;
  margin-left: 1rem;
}
.initial-text{
  font-weight: bold;
  font-size: 1.1rem;
}
.head-text{
  font-weight: bold;
  margin-left: 1rem;
}
.container-terminal{
  height: 90%;
}
.command-terminal{
  white-space: pre-line;
}
</style>
